import { render, staticRenderFns } from "./profileBuSiupal.vue?vue&type=template&id=2817a0c4&scoped=true&"
import script from "./profileBuSiupal.vue?vue&type=script&lang=js&"
export * from "./profileBuSiupal.vue?vue&type=script&lang=js&"
import style0 from "./profileBuSiupal.vue?vue&type=style&index=0&id=2817a0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2817a0c4",
  null
  
)

export default component.exports